import React from 'react';
import {Link} from 'react-router-dom';
import Icon from 'shared/components/icon';

interface Props {
  title: string;
  description: string;
  completed: boolean;
  cta?: () => void;
  url?: string;
}

export const ChecklistItem = ({title, completed, cta, url, description}: Props) => {
  const body = (
    <>
      <div className={`checklist-item-icon ${completed ? 'completed' : ''}`}>
        <Icon iconType="check" />
      </div>
      <div className="checklist-item-description">
        <h4 className={`checklist-item-header ${completed ? 'completed' : ''}`}>{title}</h4>
        {completed ? <div className="completed-subheading">Completed!</div> : description}
      </div>
    </>
  );

  return url ? (
    <Link className="checklist-item" to={url}>
      {body}
    </Link>
  ) : (
    <button className="checklist-item" disabled={completed} onClick={cta}>
      {body}
    </button>
  );
};

export const FinishedItem = ({firstName}: {firstName: string}) => (
  <div className="checklist-item finished-checklist-item">
    <div className="checklist-item-icon finished">
      <Icon iconType="trophy" />
    </div>
    <div className="checklist-item-description">
      <h4 className="checklist-item-header">{`Congrats, ${firstName}! You're a pro!`}</h4>
    </div>
  </div>
);
